import _ from 'underscore';
import {assetExpirationEnabled} from '@netx/core-asset-expiration/enablers/assetExpirationEnabled';
import {checksumEnabled} from '@netx/core-asset-next/enablers/checksumEnabled';
import {session} from '@netx/core-auth/collections/singleton/session';
import {permissionsEnabled} from '@netx/core-permissions-next/enablers/permissionsEnabled';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {type IAttributeTemplate} from '../schema';

/**
 * Correct raw attribute template data as returned by the server:
 * remaps a handful of system attribute names, drops fields that are gated
 * behind feature flags/session state, and forces `mandatory`/`permission`
 * for the `name`/`file` system attributes (-100/-101).
 *
 * Used by both the modern `getAttributeTemplates` API call and (via
 * `@netx/core-asset/collections/attributes`) the legacy Backbone collection's
 * fetch parsers, so both apply the exact same correction.
 */
export function correctAttributeTemplates(
	attrs: IAttributeTemplate[],
): IAttributeTemplate[] {
	return _.compact(
		_.map(attrs, (attr: any) => {
			let attrName = attr.name;

			// We now allow some editing of system attributes as if they were regular attributes
			// turns out the server is not considering this data mandatory on their end
			// DAM-19292 - when this ticket is done we can remove this piece of code
			if ([-100, -101].includes(attr.attributeid)) {
				attr.mandatory = 1;
				attr.permission = permissionsEnabled()
					? true
					: currentUserMeetsUserLevel(UserLevel.MANAGER);
			}

			if (
				(attrName !== 'checksum' || session.getToken() || checksumEnabled()) &&
				(attrName !== 'expireDate' ||
					assetExpirationEnabled() ||
					session.getToken()) &&
				attrName !== 'path' &&
				attrName !== 'modUser' &&
				attrName !== 'thumbPath'
			) {
				if (attr.system) {
					switch (attrName) {
						case 'fileSize':
							attrName = 'fileSize2';
							break;
						case 'creationDate':
							attrName = 'creationdate';
							break;
						case 'expireDate':
							attrName = 'expirationDate';
							break;
						case 'fileType':
							attrName = 'filetypelabel';
							break;
						case 'modDate':
							attrName = 'moddate';
							break;
					}
				}
				return _.extend(attr, {
					name: attrName,
				});
			}
		}),
	) as IAttributeTemplate[];
}

export default correctAttributeTemplates;
